import React from 'react';
import './styles/Login.css';
import {Link} from 'react-router-dom';
import { FaUser } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import Swal from 'sweetalert2';

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

//Enviar datos a la API 
const handleSubmit = async (e) => {
    e.preventDefault();

    const params = new URLSearchParams(window.location.search);
    const from = params.get('from');

    //Datos del formulario
    const dataForm = {
        input1: e.target.input1.value,
        input2: e.target.input2.value,
    };

    //Buscar datos en la base de datos 
    try{
        const response = await fetch(`${baseUrl}/api/users/search/${dataForm.input1}`, {
            method: "GET",
            headers: {
            'Content-Type': 'application/json', 
            },
        });

        // Verificar si la respuesta es exitosa
        if (!response.ok) {
            throw new Error("Usuario no encontrado o error en la respuesta");
        }
        
        const user = await response.json();

        const coincidenRes = await fetch(`${baseUrl}/api/users/contrasenna`, {
            method: "POST",
            headers: {
            'Content-Type': 'application/json', 
            },
            body: JSON.stringify({
                contrasennaIntroducida: dataForm.input2,
                contrasennaUsuario: user.Contrasenna,
            }),
        });

        if (!coincidenRes.ok) {
            // Leemos el error que venga del backend
            const errJSON = await coincidenRes.json();
            throw new Error(errJSON.error || "Error al comprobar la contraseña");
        }

        const { coinciden } = await coincidenRes.json();
        

        if(!coinciden){
            Swal.fire({
                icon: 'error',
                title: 'Contraseña incorrecta',
                text: 'La contraseña es incorrecta',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        /*if(user.Contrasenna !== dataForm.input2){
            alert("Contraseña incorrecta");
            return;
        }*/
        
        await Swal.fire({
            icon: 'success',
            title: '¡Inicio de sesión exitoso!',
            confirmButtonText: 'Continuar'
        });
        localStorage.setItem("userLogueado", JSON.stringify(user));

        if (from) {
            window.location.href = from;
        return;
        }
        
        if(user.Tipo === "Cliente") window.location.href = "/cliente";
        else if(user.Tipo === "Tutor") window.location.href = "/tutor";
        
        else window.location.href = "/"; 


    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Error al iniciar sesión',
            text: 'No se ha encontrado el usuario o la contraseña es incorrecta',
            confirmButtonText: 'Aceptar'
        });
        console.error(error);
    }
};


const LoginForm = () => {
    return (
        <div className='login'>
            <div className='wrapperLogin'>
                <form onSubmit={handleSubmit}>
                    <h1>Iniciar sesión</h1>
                    <div className="input-boxL">
                        <input type="text" name="input1" placeholder="Nombre de usuario o email" required/>
                        <FaUser className='icon' />
                    </div>
                    <div className="input-boxL">
                        <input type="password" name="input2" placeholder='Contraseña' required />
                        <FaLock  className='icon' />
                    </div>

                    <div className="forgotPassL">
                        <Link to="OlvidoSuContraseña">¿Olvidaste tu constraseña?</Link>
                    </div>

                    <button type="submit">Iniciar sesión</button>
                    <div className="register-linkL">
                        <p>¿No tienes cuenta aún? <Link to="/register">Registrate</Link>
                        </p>
                    </div>
                </form> 
            </div>
        </div>
    );
};

export default LoginForm;